import { Target } from 'lucide-react';
import { motion } from 'motion/react';

import { RecentItem, useRecentItems } from '../../hooks/useRecentItems';
import { CommandGroup, CommandItem } from '../ui/command';

interface RecentItemsProps {
  onHover?: (item: RecentItem) => void;
  onSelect: (item: RecentItem) => void;
}

const formatMetadata = (item: RecentItem): string => {
  const parts: string[] = [];
  if (item.metadata?.stage) parts.push(item.metadata.stage);
  if (item.metadata?.status) parts.push(item.metadata.status);
  return parts.join(' · ');
};

export function RecentItems({ onHover, onSelect }: RecentItemsProps) {
  const { getRecentItems } = useRecentItems();
  const recentItems = getRecentItems(15).filter(
    item => item.type === 'opportunity'
  );

  if (recentItems.length === 0) {
    return (
      <CommandGroup heading="Recent">
        <div className="text-muted-foreground px-2 py-6 text-center text-sm">
          No recent items
        </div>
      </CommandGroup>
    );
  }

  return (
    <CommandGroup heading="Recent">
      {recentItems.map((item, index) => {
        const metadata = formatMetadata(item);

        return (
          <motion.div
            animate={{ opacity: 1, x: 0 }}
            initial={{ opacity: 0, x: -10 }}
            key={`${item.type}-${item.id}`}
            transition={{ delay: index * 0.05, duration: 0.2 }}
          >
        <CommandItem
          className="flex items-center gap-3 px-3 py-2"
          onMouseEnter={() => onHover?.(item)}
          onSelect={() => {
            onSelect(item);
          }}
          value={`${item.type}-${item.id}-${item.name}`}
        >
          <Target className="text-muted-foreground h-4 w-4" />
          <div className="flex flex-col overflow-hidden">
            <span className="font-medium">{item.name}</span>
            {metadata && (
              <span className="text-muted-foreground truncate text-xs">
                {metadata}
              </span>
            )}
          </div>
        </CommandItem>
          </motion.div>
        );
      })}
    </CommandGroup>
  );
}
